(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["significant-accordion"] && !Shopify.designMode) return;
  try {
    
  const accordionItems = document.querySelectorAll('.accordion-item');
  const image = document.querySelector('.column-right img');

  accordionItems[0].classList.add('active');
  image.setAttribute('src', accordionItems[0].getAttribute('data-image-src'));

  accordionItems.forEach((item) => {
    const header = item.querySelector('.accordion-header');
    const content = item.querySelector('.accordion-content');
    const imageSrc = item.getAttribute('data-image-src');

    header.addEventListener('click', () => {
      if (!item.classList.contains('active')) {
        accordionItems.forEach((otherItem) => {
          otherItem.classList.remove('active');
          otherItem.querySelector('.accordion-content').style.maxHeight = '0';
        });

        item.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
        image.setAttribute('src', imageSrc);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
